import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../../../services/admin/admin.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { NotificationDialogComponent } from './dialogs/notification-dialog/notification-dialog.component';
import { ReviewResultsDialogComponent } from './dialogs/review-results-dialog/review-results-dialog.component';
import { AgreementDialogComponent } from './dialogs/agreement-dialog/agreement-dialog.component';
import { RefusalDialogComponent } from './dialogs/refusal-dialog/refusal-dialog.component';
import { MovementHistoryDialogComponent } from './dialogs/movement-history-dialog/movement-history-dialog.component';
import { AuthorInfoDialogComponent } from './dialogs/author-info-dialog/author-info-dialog.component';
import { SupportersListDialogComponent } from './dialogs/supporters-list-dialog/supporters-list-dialog.component';
import { ImageDialogComponent } from './dialogs/image-dialog/image-dialog.component';
import { DescriptionDialogComponent } from './dialogs/description-dialog/description-dialog.component';
import { StartVoteDialogComponent } from './dialogs/start-vote-dialog/start-vote-dialog.component';
import { DefectDialogComponent } from './dialogs/defect-dialog/defect-dialog.component';
import { BlockDialogComponent } from './dialogs/block-dialog/block-dialog.component';
import { PrepateAnswerDialogComponent } from './dialogs/prepate-answer-dialog/prepate-answer-dialog.component';
import { SendForDiscussDialogComponent } from './dialogs/send-for-discuss-dialog/send-for-discuss-dialog.component';
import { ViewMayorCommentDialogComponent } from './dialogs/view-mayor-comment-dialog/view-mayor-comment-dialog.component';
import { ExecutorAnswerDialogComponent } from './dialogs/executor-answer-dialog/executor-answer-dialog.component';
import { ExecutorAction } from '../../../../../shared/admin-models/interfaces/executor-action.interface';
import { TdLoadingService } from '@covalent/core';
import { TranslationsService } from '../../../../../services/admin/translations.servise';
import { PetitionAdminConfigs } from '../../../../../shared/admin-models/interfaces/petition-admin-configs.interface';

@Component({
  selector: 'app-petition-details',
  templateUrl: './petition-details.component.html',
  styleUrls: ['./petition-details.component.scss']
})
export class PetitionDetailsComponent implements OnInit {
  ideaId: number;
  selectedPetition: any;
  executorActionBtnConfig: any = {};
  showDefectedTable = false;
  defectedPetitions: any;
  signersNeededAmount: number;
  constructor(
    private _activatedRoute: ActivatedRoute,
    public adminService: AdminService,
    private _matDialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _loadingService: TdLoadingService,
    private _TranslationsServise: TranslationsService
  ) {}

  ngOnInit() {
    this._getIdeaId();
    this._fetchPetitionDetails();
    this.getDefectedPetitions();
    this.getconfigs();
  }

  private _getIdeaId() {
    this.ideaId = parseInt(
      this._activatedRoute.snapshot.paramMap.get('idea-id'),
      10
    );
  }

  private _fetchPetitionDetails() {
    this._loadingService.register();
    this.adminService.getIdeaById(this.ideaId).subscribe(
      (res: any) => {
        this.selectedPetition = res;
        this._loadingService.resolve();
        if (
          (Math.abs(this.selectedPetition.statusId) === 8 ||
            Math.abs(this.selectedPetition.statusId) === 13) &&
          (this.IsExecute || this.isPerform || this.isSupervise)
        ) {
          this.showExecutorActionBtns();
        }
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  get isMayor() {
    return this.adminService.isMayor;
  }
  get IsExecute() {
    return this.adminService.IsExecute;
  }
  get isPerform() {
    return this.adminService.isPerform;
  }
  get isSupervise() {
    return this.adminService.isSupervise;
  }
  get isReview() {
    return this.adminService.isReview;
  }
  absValue(num: number): number {
    return Math.abs(num);
  }
  // შეტყობინება
  openNotificationDialog() {
    this._matDialog.open(NotificationDialogComponent, {
      minWidth: '800px',
      data: { petition: this.selectedPetition }
    });
  }
  // განხილვის შედეგები
  openReviewResultsDialog() {
    (1);
    this._matDialog.open(ReviewResultsDialogComponent, {
      minWidth: '1200px',
      data: { petition: this.selectedPetition }
    });
  }
  openAgreementDialog() {
    const dialogRef = this._matDialog.open(AgreementDialogComponent, {
      disableClose: true,
      minWidth: '600px',
      data: this.selectedPetition
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this._fetchPetitionDetails();
      }
    });
  }
  openRefusalDialog(beforeDiscuss?: boolean) {
    const dialogRef = this._matDialog.open(RefusalDialogComponent, {
      disableClose: true,
      minWidth: '600px',
      data: { petition: this.selectedPetition, beforeDiscuss }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this._fetchPetitionDetails();
      }
    });
  }
  openMovementHistoryDialog() {
    this._matDialog.open(MovementHistoryDialogComponent, {
      minWidth: '600px',
      data: { ideaId: this.ideaId }
    });
  }
  openAuthorInfoDialog() {
    this._matDialog.open(AuthorInfoDialogComponent, {
      minWidth: '600px',
      data: this.selectedPetition
    });
  }
  openSupportersListDialog() {
    this._matDialog.open(SupportersListDialogComponent, {
      minWidth: '600px',
      data: { ideaId: this.ideaId }
    });
  }
  openImageDialog() {
    if (!this.selectedPetition.imageFileId) return;
    this._matDialog.open(ImageDialogComponent, {
      minWidth: '600px',
      data: {
        imageId: this.selectedPetition.imageFileId
      }
    });
  }
  openPetitionTextInDialog(description: string) {
    this._matDialog.open(DescriptionDialogComponent, {
      data: { description }
    });
  }
  openInVoteDialog() {
    const dialogref = this._matDialog.open(StartVoteDialogComponent, {
      minWidth: '600px',
      data: this.selectedPetition
    });
    dialogref.afterClosed().subscribe((res: string) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this._fetchPetitionDetails();
      }
    });
  }
  openDefectDialog() {
    const dialogref = this._matDialog.open(DefectDialogComponent, {
      minWidth: '600px',
      data: this.selectedPetition
    });
    dialogref.afterClosed().subscribe((res: string) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this._fetchPetitionDetails();
      }
    });
  }
  openBlockDialog() {
    const dialogRef = this._matDialog.open(BlockDialogComponent, {
      minWidth: '600px',
      data: this.selectedPetition
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this._fetchPetitionDetails();
      }
    });
  }
  openPrepareAnswerDialog() {
    const dialogRef = this._matDialog.open(PrepateAnswerDialogComponent, {
      minWidth: '600px',
      data: this.selectedPetition
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this._fetchPetitionDetails();
      }
    });
  }
  openSendForDiscussDialog() {
    const dialogRef = this._matDialog.open(SendForDiscussDialogComponent, {
      minWidth: '600px',
      data: this.selectedPetition
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this._fetchPetitionDetails();
      }
    });
  }
  openViewMayorCommentDialog() {
    this._matDialog.open(ViewMayorCommentDialogComponent, {
      minWidth: '600px',
      data: this.selectedPetition
    });
  }
  openExecutorAnswerDialog(mode: number) {
    const dialogRef = this._matDialog.open(ExecutorAnswerDialogComponent, {
      minWidth: '600px',
      data: {
        petition: this.selectedPetition,
        mode: mode
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          horizontalPosition: 'left',
          duration: 2000,
          panelClass: 'green-snackbar'
        });
        this._fetchPetitionDetails();
      }
    });
  }
  showExecutorActionBtns() {
    this._loadingService.register();
    this.adminService.employeeActionCheck(this.ideaId).subscribe(
      (res: ExecutorAction) => {
        this._loadingService.resolve();
        if (res) {
          if (res.realisable === null) {
            res.realisable = 0;
          } else if (res.realisable === false) {
            res.realisable = 1;
          } else {
            res.realisable = 2;
          }
          this.executorActionBtnConfig = res;
        }
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  exportFile(fileId: string): void {
    this.adminService.openFilePdf(fileId);
  }
  exportFileUsingOldApi(clientId, petitionId): void {
    const url = `https://apps.municipal.gov.ge/api/petition/petitionData/print/${clientId}/${petitionId}`;
    window.open(url, '_blank');
  }
  getDefectedPetitions() {
    this._loadingService.register();
    this.adminService.getDefectedPetitions(this.ideaId).subscribe(
      (res) => {
        this._loadingService.resolve();
        this.defectedPetitions = res;
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  getconfigs(): void {
    this.adminService.getConfigs().subscribe((res: PetitionAdminConfigs) => {
      this.signersNeededAmount = res.petitionCounterValue;
    });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/petition-details.component.ts